import { render, staticRenderFns } from "./FundaCarousel.vue?vue&type=template&id=41fd9316&scoped=true&"
import script from "./FundaCarousel.vue?vue&type=script&lang=js&"
export * from "./FundaCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FundaCarousel.vue?vue&type=style&index=0&id=41fd9316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd9316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VSheet})
